import { render, staticRenderFns } from "./MismatchCard.vue?vue&type=template&id=3533f6fa&scoped=true"
import script from "./MismatchCard.vue?vue&type=script&lang=js"
export * from "./MismatchCard.vue?vue&type=script&lang=js"
import style0 from "./MismatchCard.vue?vue&type=style&index=0&id=3533f6fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3533f6fa",
  null
  
)

export default component.exports